module.exports = __webpack_public_path__ + "static/media/manager-r-1.7bc61717.png";